export function getRootDomain(): string {
  if (location.hostname.includes('localhost')) {
    const [, domain] = location.hostname.match(/(localhost:\d+)/) ?? [];
    return domain as string;
  } else if (location.hostname.includes('netlify')) {
    return location.hostname;
  } else {
    return `.${location.hostname.split('.').slice(-2).join('.')}`;
  }
}
